export function gracefulDecodeURIComponent(encodedURIComponent: string): string {
    try {
        return decodeURIComponent(encodedURIComponent.replace(/\+/g, ' '))
    } catch {
        return encodedURIComponent
    }
}

export function parseUTM(query: string): Record<string, string> {
    if (query.startsWith('?')) {
        query = query.substring(1)
    }
    query = query.replace(/\?/g, '&')

    return query.split('&').reduce((acc, str) => {
        const [k, v = ''] = str.split('=')
        if (k.includes('utm_') && k.length > 4) {
            let utmParam = k.substr(4)
            if (utmParam === 'campaign') {
                utmParam = 'name'
            }
            acc[utmParam] = gracefulDecodeURIComponent(v)
        }
        return acc
    }, {} as Record<string, string>)
}
